import axios from 'axios'
import { errorHandler } from '@/api/error-handler'

export default {
  retrieve: (params, errorHandling = true) => axios.get('/flatpages', { params: params })
    .then(response => response.data)
    .catch(error => errorHandler(error, errorHandling))
}
